/* eslint-disable */
export default {
  unknown: '不明',
  anonymous: '匿名',
  activeCalls: 'すべての通話',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
